<div class="row">
  <div class="col-lg-1 col-12 px-0">
    <app-uiform-side-menu
      [uiformId]="uiformId"
      targetId="pivot"
      [usecaseId]="usecaseId"
    ></app-uiform-side-menu>
  </div>

  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left" #content>
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-title border-0 mb-3">
          <div
            class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
          >
            <mat-icon color="primary">pie_chart</mat-icon>
            <p class="text-break text-wrap mb-0">
              {{ form.data["title"] }} {{ "PIVOT.CUSTOM_REPORT" | translate }}
            </p>
            <mat-icon
              class="cursor-pointer ms-1"
              color="primary"
              [matTooltip]="'PIVOT.PDF' | translate"
              matTooltipPosition="right"
              (click)="exportPDFData()"
            >
              picture_as_pdf
            </mat-icon>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="search-card compact-inputs dropdown-pd-none">
              <div class="card-header border-bottom-0 p-0">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="toggleSearchInputs()"
                  ncsTooltip
                  [matTooltip]="'PIVOT.TOOLTIPS.FILTER' | translate"
                  matTooltipPosition="above"
                >
                <mat-icon>tune</mat-icon>
                  <span>{{ "PIVOT.BUTTONS.FILTER" | translate }}</span>
              </button>
              </div>
              <div *ngIf="showSearchInputs">
                <div>
                  <div class="row g-2 mt-2">
                  <!-- Field Selection -->
                  <div class="col-lg-auto col-md-6 col-12">
                    <div class="d-flex align-items-center">
                        <mat-form-field
                          appearance="outline"
                          class="w-100"
                          subscriptSizing="dynamic"
                        >
                          <mat-select
                            [value]="
                              searchData['field']
                                ? getSelectedFieldCode(searchData['field'])
                                : null
                            "
                          (selectionChange)="onSelectChange($event)"
                            [placeholder]="
                              'PIVOT.SELECT.DEFAULT_FIELD' | translate
                            "
                            (openedChange)="onSelectOpened($event)"
                          >
                          <!-- Selected value display - WITHOUT icon -->
                          <mat-select-trigger>
                              <div
                                class="d-flex align-items-center"
                                *ngIf="searchData['field']"
                              >
                                <ng-container
                                  *ngFor="let field of filterAttributes"
                                >
                                  <ng-container
                                    *ngIf="field.code === searchData['field']"
                                  >
                                    <span
                                      class="text-truncate"
                                      [title]="searchView['field']"
                                    >
                                      {{
                                        transform(searchView["field"], 15) ||
                                          searchView["field"]
                                      }}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>
                            <span *ngIf="!searchData['field']">
                                {{ "PIVOT.SELECT.DEFAULT_FIELD" | translate }}
                            </span>
                          </mat-select-trigger>

                          <!-- Options -->
                            <mat-option
                              *ngFor="let e of filterAttributes"
                              [value]="e"
                            >
                            <div class="d-flex align-items-center gap-2 py-1">
                                <span
                                  class="badge"
                                  [ngClass]="getButtonClass(e['type'])"
                                >
                                {{ getButtonLabels(e["type"]) }}
                              </span>
                                <span
                                  [matTooltip]="e['label']"
                                  class="text-truncate"
                                >
                                {{ e["label"] }}
                              </span>
                            </div>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                        <mat-icon
                          class="icon-compact text-secondary"
                          [matTooltip]="
                            'PIVOT.TOOLTIPS.SELECT_FIELD' | translate
                          "
                          matTooltipPosition="above"
                          >info</mat-icon
                        >
                    </div>
                  </div>

                  <!-- Condition Selection -->
                  <div class="col-lg-auto col-md-6 col-12">
                    <div class="d-flex align-items-center">
                      <mat-form-field appearance="outline" class="w-100">
                          <mat-select
                            [(ngModel)]="searchData['condition']"
                            (ngModelChange)="onConditionChange()"
                            name="condition"
                            [placeholder]="
                              'PIVOT.SELECT.DEFAULT_CONDITION' | translate
                            "
                          >
                            <mat-option
                              *ngFor="let e of operators"
                              [value]="e.value"
                            >
                            {{ e.label | translate }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                        <mat-icon
                          [matTooltip]="'PIVOT.TOOLTIPS.CONDITION' | translate"
                          matTooltipPosition="above"
                          class="text-secondary icon-compact"
                          >info</mat-icon
                        >
                    </div>
                  </div>

                  <!-- Value Input Section -->
                  <div class="col-lg-auto col-md-12">
                      <div
                        class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-1"
                      >
                      <!-- Main container with nowrap to keep everything on one line -->
                      <div class="d-flex flex-sm-nowrap align-items-center">
                          <ng-container
                            *ngIf="
                              !['NULL', 'NOT NULL', 'EMPTY'].includes(
                                searchData['condition']
                              )
                            "
                          >
                          <!-- Custom Day Dropdown -->
                            <div
                              class="custom-dropdown-wrapper flex-shrink-0"
                              *ngIf="
                                searchData['condition'] === 'DAY' &&
                                selectedSearchAtt === 'date'
                              "
                              style="min-width: 90px"
                            >
                              <div
                                class="custom-dropdown"
                                (click)="
                                  toggleDayDropdown(); $event.stopPropagation()
                                "
                              >
                                <span>{{ selectedDay || "Day" }}</span>
                              <i class="fa fa-chevron-down"></i>
                            </div>
                            <ul *ngIf="dayDropdownOpen" class="dropdown-list">
                                <li
                                  *ngFor="let day of days; let i = index"
                                  [class.sticky-first-item]="i === 0"
                                  (click)="
                                    selectDay(day); $event.stopPropagation()
                                  "
                                >
                                {{ day }}
                                  <div
                                    *ngIf="i === 0"
                                    class="dropdown-separator"
                                  ></div>
                              </li>
                            </ul>
                          </div>

                          <!-- Custom Month Dropdown -->
                            <div
                              class="custom-dropdown-wrapper flex-shrink-0"
                              *ngIf="
                                searchData['condition'] === 'MONTH' &&
                                selectedSearchAtt === 'date'
                              "
                              style="min-width: 90px"
                            >
                              <div
                                class="custom-dropdown"
                                (click)="
                                  toggleMonthDropdown();
                                  $event.stopPropagation()
                                "
                              >
                                <span>{{
                                  getMonthName(selectedMonth) || "Month"
                                }}</span>
                              <i class="fa fa-chevron-down"></i>
                            </div>
                              <ul
                                *ngIf="monthDropdownOpen"
                                class="dropdown-list"
                              >
                                <li
                                  *ngFor="let month of months; let i = index"
                                  [class.sticky-first-item]="i === 0"
                                  (click)="
                                    selectMonth(month); $event.stopPropagation()
                                  "
                                >
                                {{ month.name }}
                                  <div
                                    *ngIf="i === 0"
                                    class="dropdown-separator"
                                  ></div>
                              </li>
                            </ul>
                          </div>

                          <!-- Day + Month Combined -->
                            <div
                              *ngIf="
                                searchData['condition'] === 'DAY_AND_MONTH' &&
                                selectedSearchAtt === 'date'
                              "
                              class="d-flex gap-1 flex-shrink-0"
                            >
                              <div
                                class="custom-dropdown-wrapper"
                                style="min-width: 70px"
                              >
                                <div
                                  class="custom-dropdown custom-dropdown_dm"
                                  (click)="
                                    toggleDayDropdown();
                                    $event.stopPropagation()
                                  "
                                >
                                  <span>{{ selectedDay || "D" }}</span>
                                <i class="fa fa-chevron-down"></i>
                              </div>
                                <ul
                                  *ngIf="dayDropdownOpen"
                                  class="dropdown-list"
                                >
                                  <li
                                    *ngFor="let day of days; let i = index"
                                    [class.sticky-first-item]="i === 0"
                                    (click)="
                                      selectDayForDayMonth(day);
                                      $event.stopPropagation()
                                    "
                                  >
                                  {{ day }}
                                    <div
                                      *ngIf="i === 0"
                                      class="dropdown-separator"
                                    ></div>
                                </li>
                              </ul>
                            </div>
                              <div
                                class="custom-dropdown-wrapper"
                                style="min-width: 70px"
                              >
                                <div
                                  class="custom-dropdown custom-dropdown_dm"
                                  (click)="
                                    toggleMonthDropdown();
                                    $event.stopPropagation()
                                  "
                                >
                                  <span>{{
                                    getMonthName(selectedMonth) || "M"
                                  }}</span>
                                <i class="fa fa-chevron-down"></i>
                              </div>
                                <ul
                                  *ngIf="monthDropdownOpen"
                                  class="dropdown-list"
                                >
                                  <li
                                    *ngFor="let month of months; let i = index"
                                    [class.sticky-first-item]="i === 0"
                                    (click)="
                                      selectMonthForDayMonth(month);
                                      $event.stopPropagation()
                                    "
                                  >
                                  {{ month.name }}
                                    <div
                                      *ngIf="i === 0"
                                      class="dropdown-separator"
                                    ></div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <!-- Regular Inputs (Text, Number, Date) -->
                            <ng-container
                              *ngIf="searchData['condition'] !== 'BETWEEN'"
                            >
                            <!-- Text Input -->
                            <mat-form-field
                                *ngIf="
                                  selectedSearchAtt != 'number' &&
                                  selectedSearchAtt != 'expression' &&
                                  selectedSearchAtt != 'long' &&
                                  selectedSearchAtt != 'date'
                                "
                                appearance="outline"
                                class="flex-grow-1"
                                subscriptSizing="dynamic"
                                style="min-width: 120px"
                              >
                                <input
                                  matInput
                                  [(ngModel)]="searchData['value']"
                                  [placeholder]="
                                    'PIVOT.PLACEHOLDERS.ENTER_VALUE' | translate
                                  "
                                  type="text"
                                />
                            </mat-form-field>

                            <!-- Number Input -->
                            <mat-form-field
                                *ngIf="
                                  selectedSearchAtt === 'number' ||
                                  selectedSearchAtt === 'expression' ||
                                  selectedSearchAtt === 'long'
                                "
                                appearance="outline"
                                class="flex-grow-1"
                                subscriptSizing="dynamic"
                                style="min-width: 120px"
                              >
                                <input
                                  matInput
                                  [(ngModel)]="searchData['value']"
                                  placeholder="Value"
                                  type="number"
                                />
                            </mat-form-field>

                              <mat-form-field
                                appearance="outline"
                                class="w-100"
                                *ngIf="
                                  selectedSearchAtt === 'date' &&
                                  searchData['condition'] != 'DAY' &&
                                  searchData['condition'] != 'MONTH' &&
                                  searchData['condition'] != 'DAY_AND_MONTH'
                                "
                              >
                                <input
                                  matInput
                                  type="date"
                                  #dateInput
                                  [(ngModel)]="searchData['value']"
                                />
                                <button
                                  mat-icon-button
                                  matSuffix
                                  type="button"
                                  class="icon-pd-none"
                                  (click)="dateInput.showPicker()"
                                  aria-label="Open date picker"
                                >
                                  <mat-icon class="icon-compact text-secondary"
                                    >event</mat-icon
                                  >
                              </button>
                            </mat-form-field>
                          </ng-container>

                          <!-- BETWEEN Range - COMPACT DESIGN -->
                            <ng-container
                              *ngIf="searchData['condition'] === 'BETWEEN'"
                            >
                              <div
                                class="d-flex flex-nowrap align-items-center"
                                style="flex: 1"
                              >
                              <!-- Text Range - Compact -->
                                <ng-container
                                  *ngIf="selectedSearchAtt === 'text'"
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    class=""
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeFrom']"
                                      placeholder="Enter From value"
                                      type="text"
                                    />
                                </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    class=""
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeTo']"
                                      placeholder="Enter To value"
                                      type="text"
                                    />
                                </mat-form-field>
                              </ng-container>

                              <!-- Number Range - Compact -->
                              <ng-container
                                  *ngIf="
                                    selectedSearchAtt === 'number' ||
                                    selectedSearchAtt === 'expression' ||
                                    selectedSearchAtt === 'long'
                                  "
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    class=""
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeFrom']"
                                      placeholder="From"
                                      type="number"
                                    />
                                </mat-form-field>
                                <span class="text-muted mx-0">-</span>
                                  <mat-form-field
                                    appearance="outline"
                                    class=""
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeTo']"
                                      placeholder="To"
                                      type="number"
                                    />
                                </mat-form-field>
                              </ng-container>

                              <!-- Date Range -->
                                <input
                                  *ngIf="selectedSearchAtt === 'date'"
                                  type="text"
                                  class="form-control form-control-sm"
                                  ngxDaterangepickerMd
                                  [(ngModel)]="searchData['rangeDate']"
                                  [showCustomRangeLabel]="true"
                                  [alwaysShowCalendars]="true"
                                  [ranges]="ranges"
                                  [showDropdowns]="true"
                                  [linkedCalendars]="true"
                                  placeholder="Range"
                                  style="width: 180px"
                                />
                            </div>
                          </ng-container>

                          <!-- Tooltip Icon -->
                            <mat-icon
                              *ngIf="selectedSearchAtt"
                              class="icon-compact text-secondary"
                            [matTooltip]="'TOOLTIPS.FILTER_VALUE' | translate"
                              matTooltipPosition="above"
                              >info</mat-icon
                            >
                        </ng-container>
                      </div>
                      <!-- Add Button - Always visible with full text -->
                        <!-- AND/OR selector + Add Button -->
                        <div
                          class="d-flex align-items-center gap-2 flex-shrink-0"
                        >
                          <!-- AND/OR toggle - only show when at least 1 filter exists -->
                          <!-- <div *ngIf="searchList.length > 0"
    class="btn-group btn-group-sm" role="group">
    <button type="button"
      class="btn btn-sm"
      [ngClass]="currentLogicalOperator === 'AND' ? 'btn-primary' : 'btn-outline-primary'"
      (click)="setLogicalOperator('AND')">
      AND
    </button>
    <button type="button"
      class="btn btn-sm"
      [ngClass]="currentLogicalOperator === 'OR' ? 'btn-warning text-dark' : 'btn-outline-warning'"
      (click)="setLogicalOperator('OR')">
      OR
    </button>
  </div> -->

                          <!-- Existing Add button -->

                          <!-- AND/OR selector + Add Button -->
                          <div
                            class="d-flex align-items-center gap-2 flex-shrink-0"
                          >
                            <!-- AND/OR toggle - only show when at least 1 filter exists -->
                            <div
                              *ngIf="searchList.length > 0"
                              class="btn-group btn-group-sm"
                              role="group"
                            >
                              <!-- <button type="button"
      class="btn btn-sm"
      [ngClass]="currentLogicalOperator === 'AND' ? 'btn-primary' : 'btn-outline-primary'"
      (click)="setLogicalOperator('AND')">
      AND
    </button> -->

                              <button
                                mat-stroked-button
                                [color]="
                                  currentLogicalOperator === 'AND'
                                    ? 'primary'
                                    : ''
                                "
                                (click)="setLogicalOperator('AND')"
                              >
                                AND
                              </button>

                              <!-- <button type="button"
      class="btn btn-sm"
      [ngClass]="currentLogicalOperator === 'OR' ? 'btn-warning text-dark' : 'btn-outline-warning'"
      (click)="setLogicalOperator('OR')">
      OR
    </button> -->

                              <button
                                mat-stroked-button
                                [color]="
                                  currentLogicalOperator === 'OR' ? 'warn' : ''
                                "
                                (click)="setLogicalOperator('OR')"
                              >
                                OR
                              </button>
                            </div>

                            <!-- Existing Add button -->
                            <button
                              mat-stroked-button
                              color="primary"
                              class="flex-shrink-0"
                              [disabled]="
                                (!searchData['value'] &&
                                  !searchData['condition'] &&
                                  !searchData['field']) ||
                                (searchList.length > 0 &&
                                  !currentLogicalOperator)
                              "
                              (click)="addSearchData()"
                            >
                              <mat-icon>add</mat-icon>
                              <span>{{ "PIVOT.BUTTONS.ADD" | translate }}</span>
                            </button>
                          </div>
                          <!-- <button mat-stroked-button color="primary" class="flex-shrink-0"
                        [disabled]="!searchData['value'] && !searchData['condition'] && !searchData['field']"
                        (click)="addSearchData()">
                        <mat-icon>add</mat-icon>
                        <span>{{'PIVOT.BUTTONS.ADD' | translate}} </span>
                       </button> -->
                        </div>
                    </div>
                  </div>
                </div>

                  <!-- Applied Filters with AND/OR badges -->
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="d-flex flex-wrap align-items-center gap-1">
                        <ng-container
                          *ngFor="let e of searchViewList; let i = index"
                        >
                          <!-- AND/OR badge between filters (not before the first) -->
                          <span
                            *ngIf="i > 0"
                            class="badge rounded-pill px-2 py-1"
                            [ngClass]="
                              e.logicalOperator === 'OR'
                                ? 'bg-warning text-dark'
                                : 'bg-primary'
                            "
                          >
                            {{ e.logicalOperator || "AND" }}
                          </span>

                          <!-- Filter chip -->
                          <button
                            (click)="removeSearchData(i)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm p-1 d-inline-flex align-items-center"
                          >
                        <ng-container [ngSwitch]="e.condition">
                          <span *ngSwitchCase="'Day'">
                                {{ e.field }} {{ e.condition }} :
                                {{ e.value?.split("-")[2] }}
                          </span>
                          <span *ngSwitchCase="'Month'">
                                {{ e.field }} {{ e.condition }} :
                                {{ e.value?.split("-")[1] }}
                          </span>
                          <span *ngSwitchCase="'Day & Month'">
                                {{ e.field }} Day:
                                {{ e.value?.split("-")[2] }} Month:
                                {{ e.value?.split("-")[1] }}
                          </span>
                          <span *ngSwitchDefault>
                                {{ e.field }} {{ e.condition }} {{ e.value }}
                                {{ e.rangeFrom }} {{ e.rangeTo }}
                          </span>
                        </ng-container>
                        <i class="fa fa-times ms-1 fs-6"></i>
                      </button>
                        </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Action Buttons -->
                <div class="row mt-2">
                  <div class="col-12">
                    <div class="d-flex align-items-center gap-2">
                        <button
                          mat-stroked-button
                          color="primary"
                          class=""
                          (click)="searchAndDraw(true)"
                        >
                        <mat-icon class="me-1">search</mat-icon>
                          {{ "PIVOT.BUTTONS.SEARCH" | translate }}
                      </button>

                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="resetSearchCriteria()"
                        >
                        <i class="fa fa-eraser"></i>
                          <span class="ms-2">{{
                            "PIVOT.BUTTONS.FILTER" | translate
                          }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>

            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mt-3"
            >
              <div
                class="d-flex align-items-center gap-2 cursor-pointer"
                (click)="toggleInputs()"
              >
                <mat-icon color="primary" class="fs-4">assessment</mat-icon>
                <h6 class="mb-0 fw-semibold">
                  {{ "PIVOT.CREATE_REPORT" | translate }}
                </h6>
              </div>
              <span
                data-bs-toggle="modal"
                data-bs-target="#info"
                class="cursor-pointer"
              >
                <i class="bi bi-info-circle fs-5 text-secondary"></i>
              </span>
            </div>

            <form
              class="px-3 py-3 mb-2 compact-inputs dropdown-pd-none"
              #chartForm="ngForm"
              *ngIf="showFilterInputs"
            >
              <div class="pdf-exclude">
                <!-- I Want Section - Row 1 -->
                <div class="row g-2 align-items-start mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2">
                        <label for="SelectValues" class="h6 fw-medium mb-0 text-wrap">
                          <!-- {{ 'PIVOT.I_WANT' | translate }} : -->
                          Select Aggregation for Y-Axis :
                        </label>
                      </div>
                      <!-- Controls Column - Takes remaining space -->
                      <div class="col-xl-10 col-lg-9 col-md-8 col-12">
                        <div class="row g-2">
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['values']"
                                placeholder="{{
                                  'PIVOT.SELECT.DEFAULT_SELECT' | translate
                                }}"
                              >
                                <mat-select-trigger>
                                  {{ pivotform["values"] }}
                                </mat-select-trigger>
                                <mat-option
                                  *ngFor="let e of filterAttributes"
                                  [value]="e['label']"
                                >
                                  <div class="d-flex align-items-center gap-2">
                                    <span
                                      class="badge fw-light iconSize"
                                      [ngClass]="getButtonClass(e['type'])"
                                    >
                                      {{ getButtonLabels(e["type"]) }}
                                    </span>
                                    <span
                                      [title]="e['label']"
                                      class="text-truncate"
                                      >{{ e["label"] }}</span
                                    >
                                  </div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <!-- Aggregation type select  -->
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['aggfunc']"
                                #aggType1
                              >
                                <mat-option
                                  *ngFor="let agg of aggregationTypes"
                                  [value]="agg.value"
                                >
                                  {{ agg.label | translate }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="col-12 col-sm-auto">
                            <div class="row g-2">
                              <!-- Add button -->
                              <div class="col-6 col-sm-auto">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="w-100"
                                  [disabled]="
                                    !pivotform['aggfunc'] ||
                                    !pivotform['values']
                                  "
                                  (click)="
                                    updateFormField(
                                      'aggfunc',
                                      pivotform['values'],
                                      aggType1.value,
                                      true
                                    )
                                  "
                                >
                                  <mat-icon>add</mat-icon>
                                  <span>{{
                                    "PIVOT.BUTTONS.ADD" | translate
                                  }}</span>
                                </button>
                              </div>

                              <!-- Info tooltip -->
                              <div
                                class="col-6 col-sm-auto d-flex align-items-center"
                              >
                                <span
                                  [matTooltip]="
                                    'PIVOT.TOOLTIPS.AGGREGATION' | translate
                                  "
                                  matTooltipPosition="right"
                                  class="d-flex align-items-center"
                                >
                                  <mat-icon class="icon-compact text-secondary"
                                    >info</mat-icon
                                  >
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Chips Column -->
                      <div
                        class="col-12 mt-2"
                        *ngIf="
                          reqform?.['aggfunc'] &&
                          objectEntries(reqform['aggfunc']).length
                        "
                      >
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            *ngFor="
                              let entry of objectEntries(reqform['aggfunc'])
                            "
                            (click)="removeFormField('aggfunc', entry[0], true)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 mb-1 p-1"
                          >
                            {{ entry[0] }} ({{ entry[1] }})
                            <i class="fa fa-times ms-1 fs-6"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Category By Section - Row 2 -->
                <div class="row g-2 align-items-start mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label class="h6 fw-medium mb-0 text-nowrap">
                          <!-- {{ 'PIVOT.CATEGORY_BY' | translate }} : -->
                            Group By :
                        </label>
                      </div>

                      <!-- Controls Column -->
                      <div class="col-xl-10 col-lg-9 col-md-8 col-12">
                        <div class="row g-2">
                          <!-- Category Selection Dropdown -->
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['columns']"
                                [placeholder]="
                                  'PIVOT.SELECT.DEFAULT_SELECT' | translate
                                "
                              >
                                <mat-select-trigger>
                                  {{ pivotform["columns"] }}
                                </mat-select-trigger>
                                <mat-option
                                  *ngFor="let e of filterRowColumns()"
                                  [value]="e['label']"
                                  (click)="selectColumn(e['label'], 'columns')"
                                >
                                  <div class="d-flex align-items-center gap-2">
                                    <span
                                      class="badge fw-light iconSize"
                                      [ngClass]="getButtonClass(e['type'])"
                                    >
                                      {{ getButtonLabels(e["type"]) }}
                                    </span>
                                    <span
                                      [title]="e['label']"
                                      class="text-truncate"
                                      >{{ e["label"] }}</span
                                    >
                                  </div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="col-12 col-sm-auto">
                            <div class="row g-2">
                              <!-- Add button -->
                              <div class="col-6 col-sm-auto">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="w-100"
                                  [disabled]="!pivotform['columns']"
                                  (click)="
                                    updateFormField(
                                      'columns',
                                      pivotform['columns']
                                    )
                                  "
                                >
                                  <mat-icon>add</mat-icon>
                                  <span>{{
                                    "PIVOT.BUTTONS.ADD" | translate
                                  }}</span>
                                </button>
                              </div>

                              <!-- Info tooltip -->
                              <div
                                class="col-6 col-sm-auto d-flex align-items-center"
                              >
                                <span
                                  [matTooltip]="
                                    'PIVOT.TOOLTIPS.CATEGORY' | translate
                                  "
                                  matTooltipPosition="right"
                                  class="d-flex align-items-center text-secondary"
                                >
                                  <mat-icon class="icon-compact">info</mat-icon>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Chips Column -->
                      <div
                        class="col-12 mt-2"
                        *ngIf="reqform['columns']?.length > 0"
                      >
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            *ngFor="let e of reqform['columns']"
                            (click)="removeFormField('columns', e)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 mb-1"
                          >
                            {{ e }}
                            <i class="fa fa-times ms-1 fs-6"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Group By Section - Row 3 -->
                <div class="row g-2 align-items-start mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label class="h6 fw-medium mb-0 text-nowrap">
                          <!-- {{ 'PIVOT.GROUP_BY' | translate }} : -->
                            X-Axis :
                        </label>
                      </div>

                      <!-- Controls Column -->
                      <div class="col-xl-10 col-lg-9 col-md-8 col-12">
                        <div class="row g-2">
                          <!-- Group Selection Dropdown-->
                          <div class="col-12 col-sm-auto">
                            <mat-form-field
                              appearance="outline"
                              class="no-bottom-margin w-100"
                            >
                              <mat-select
                                [(value)]="pivotform['index']"
                                [placeholder]="
                                  'PIVOT.SELECT.DEFAULT_SELECT' | translate
                                "
                              >
                                <mat-select-trigger>
                                  {{ pivotform["index"] }}
                                </mat-select-trigger>
                                <mat-option
                                  *ngFor="let e of filterRowColumns()"
                                  [value]="e['label']"
                                  (click)="selectColumn(e['label'], 'index')"
                                >
                                  <div class="d-flex align-items-center gap-2">
                                    <span
                                      class="badge fw-light iconSize"
                                      [ngClass]="getButtonClass(e['type'])"
                                    >
                                      {{ getButtonLabels(e["type"]) }}
                                    </span>
                                    <span
                                      [title]="e['label']"
                                      class="text-truncate"
                                      >{{ e["label"] }}</span
                                    >
                                  </div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-auto">
                            <div class="row g-2">
                              <!-- Add button -->
                              <div class="col-6 col-sm-auto">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  class="w-100"
                                  [disabled]="!pivotform['index']"
                                  (click)="
                                    updateFormField('index', pivotform['index'])
                                  "
                                >
                                  <mat-icon>add</mat-icon>
                                  <span>{{
                                    "PIVOT.BUTTONS.ADD" | translate
                                  }}</span>
                                </button>
                              </div>

                              <!-- Info tooltip -->
                              <div
                                class="col-6 col-sm-auto d-flex align-items-center"
                              >
                                <span
                                  [matTooltip]="
                                    'PIVOT.TOOLTIPS.GROUP_BY' | translate
                                  "
                                  matTooltipPosition="right"
                                  class="d-flex align-items-center"
                                >
                                  <mat-icon class="icon-compact text-secondary"
                                    >info</mat-icon
                                  >
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Chips Column -->
                      <div
                        class="col-12 mt-2"
                        *ngIf="reqform['index']?.length > 0"
                      >
                        <div class="d-flex flex-wrap gap-1">
                          <button
                            *ngFor="let e of reqform['index']"
                            (click)="removeFormField('index', e)"
                            type="button"
                            class="btn btn-outline-secondary btn-sm me-1 p-1 mb-1"
                          >
                            {{ e }}
                            <i class="fa fa-times ms-1 fs-6"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Type and Show Total Section - Row 4 -->
                <div class="row g-2 align-items-center mb-3">
                  <div class="col-12">
                    <div class="row align-items-center">
                      <div
                        class="col-xl-2 col-lg-3 col-md-4 col-12 mb-md-0 mb-2"
                      >
                        <label class="h6 fw-medium mb-0 text-nowrap">
                          {{ "PIVOT.TYPE" | translate }} :
                        </label>
                      </div>

                      <!-- Type Controls -->
                      <div
                        class="col-xl-4 col-lg-5 col-md-8 col-12 mb-md-0 mb-2"
                      >
                        <div class="row g-2 align-items-center">
                          <!-- Chart Type Dropdown -->
                          <div class="col-12 col-sm-auto">
                            <div class="d-flex align-items-center gap-1">
                              <mat-form-field
                                appearance="outline"
                                class="no-bottom-margin w-100"
                              >
                                <mat-select
                                  [(ngModel)]="reqform['chart_type']"
                                  name="chartType"
                                >
                                  <mat-option
                                    *ngFor="let chart of chartTypes"
                                    [value]="chart.value"
                                  >
                                    {{ chart.icon }}
                                    {{ chart.label | translate }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <!-- Info tooltip -->
                              <span
                                [matTooltip]="
                                  'PIVOT.TOOLTIPS.VIEW_TYPE' | translate
                                "
                                matTooltipPosition="right"
                                class="d-flex align-items-center"
                              >
                                <mat-icon class="icon-compact text-secondary"
                                  >info</mat-icon
                                >
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Show Total Checkbox -->
                      <div class="col-xl-6 col-lg-4 col-md-12 mt-3 mt-sm-auto">
                        <div class="row g-2 align-items-center">
                          <div class="col-auto">
                            <mat-checkbox
                              [(ngModel)]="reqform['margins']"
                              name="showtotal"
                              color="primary"
                            >
                              <span class="h6 fw-medium">{{
                                "PIVOT.SHOW_TOTAL" | translate
                              }}</span>
                            </mat-checkbox>
                          </div>
                          <div class="col-auto">
                            <span
                              [matTooltip]="
                                'PIVOT.TOOLTIPS.SHOW_TOTAL' | translate
                              "
                              class="d-flex align-items-center text-secondary"
                            >
                              <mat-icon class="icon-compact">info</mat-icon>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons Section - Row 5 -->
                <div class="row g-3 align-items-center mt-sm-3">
                  <div class="col-12">
                    <div
                      class="d-flex flex-wrap align-items-center justify-content-between gap-3"
                    >
                      <div class="d-flex flex-wrap align-items-center gap-2">
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="searchAndDraw(true)"
                        >
                          <mat-icon>directions</mat-icon>
                          <span>{{ "COMMON.GET" | translate }}</span>
                        </button>

                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="resetSearchValues()"
                          class="pdf-exclude"
                        >
                          <i class="fa fa-eraser"></i>
                          <span class="ms-2">{{
                            "PIVOT.BUTTONS.REFRESH" | translate
                          }}</span>
                        </button>

                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="resetreportform()"
                          [disabled]="!addReport"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          <mat-icon class="me-1">add</mat-icon>
                          <span>{{
                            "PIVOT.BUTTONS.ADD_REPORT" | translate
                          }}</span>
                        </button>
                      </div>

                      <!-- Auto Update Toggle -->
                      <div
                        class="d-flex align-items-center gap-2 mt-3 mt-sm-auto"
                      >
                        <mat-slide-toggle
                          [(ngModel)]="autoUpdateReport"
                          name="autoUpdateReport"
                          (change)="toggleAutoUpdate()"
                          color="primary"
                        >
                          {{ "PIVOT.AUTO_UPDATE" | translate }}
                        </mat-slide-toggle>

                        <span
                          [matTooltip]="
                            'PIVOT.TOOLTIPS.AUTO_UPDATE' | translate
                          "
                          class="d-flex align-items-center text-secondary"
                        >
                          <mat-icon class="icon-compact">info</mat-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!-- Report Display Area -->
            <div>
              <p *ngIf="form['error'] == false && form['message']">
                <app-ncs-alert
                  [message]="form['message']"
                  type="success"
                  showAlert="true"
                />
              </p>
              <p *ngIf="form['error'] == true && form['message']">
                <app-ncs-alert
                  [message]="form['message']"
                  type="danger"
                  showAlert="true"
                />
              </p>
              <div *ngIf="loading">
                {{ "PIVOT.STATUS.LOADING" | translate }}...
              </div>
              <div *ngIf="!loading">
                  <!-- � Table -->
                  <!-- <div *ngIf="pivottable" [innerHTML]="pivottable" class="table-responsive sticky-bordered-table">
              </div> -->
                    <div *ngIf="pivottable && pivottable.includes('<table')" [innerHTML]="pivottable"
                          class="table-responsive sticky-bordered-table">
              </div>
                  <!-- � Plotly Chart -->
                  <iframe #chartIframe *ngIf="chartUrl" [src]="chartUrl" width="100%" height="600px" style="border: none;">
                  </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Report Modal -->
<div
  class="modal fade"
  id="staticBackdrop"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">
          {{ "PIVOT.MODAL.ADD_REPORT" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <p *ngIf="reportform['error'] == false && reportform['message']">
          <app-ncs-alert [message]="reportform['message']" type="success" />
        </p>
        <p *ngIf="reportform['error'] ==  true && reportform['message']">
          <app-ncs-alert [message]="reportform['message']" type="danger" />
        </p>

        <!-- Title Field -->
        <div class="row mb-3">
          <label for="title" class="col-sm-3 col-form-label"
            >{{ "PIVOT.FORM.TITLE" | translate }} :
          </label>
          <div class="col-sm-9">
            <input
              (input)="checkReportLabel($event)"
              id="title"
              name="title"
              [placeholder]="'PIVOT.PLACEHOLDERS.ENTER_TITLE' | translate"
              type="text"
              class="form-control form-control-sm"
              required
              [(ngModel)]="reportform.data['title']"
            />
            <span style="color:red">{{reportform.inputerror?.title}} </span>
          </div>
        </div>

        <!-- Subtitle Field -->
        <div class="row mb-3">
          <label for="subTitle" class="col-sm-3 col-form-label"
            >{{ "PIVOT.FORM.SUBTITLE" | translate }}:</label
          >
          <div class="col-sm-9">
            <input
              id="subTitle"
              name="subTitle"
              [placeholder]="'PIVOT.PLACEHOLDERS.ENTER_SUBTITLE' | translate"
              type="text"
              class="form-control form-control-sm"
              required
              [(ngModel)]="reportform.data['subTitle']"
            />
            <span style="color: red"
              >{{ reportform.inputerror?.subTitle }}
            </span>
          </div>
        </div>

        <!-- Description Field -->
        <div class="row mb-3">
          <label for="description" class="col-sm-3 col-form-label"
            >{{ "PIVOT.FORM.DESCRIPTION" | translate }}:</label
          >
          <div class="col-sm-9">
            <textarea
              id="description"
              name="description"
              [placeholder]="'PIVOT.PLACEHOLDERS.ENTER_DESCRIPTION' | translate"
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="reportform.data['description']"
            >
            </textarea>
            <span style="color: red">{{
              reportform.inputerror?.description
            }}</span>
          </div>
        </div>

        <div class="row mb-3">
          <label class="col-sm-3 col-form-label" for="addOnDashboardReport">
            Add on Dashboard
          </label>
          <div class="col-sm-9">
            <input
              type="checkbox"
  [ngModel]="addOnDashboardReport === 1"
              (ngModelChange)="setAddOnDashboard($event)"
            />
            <span ncsTooltip class="ms-1">
              <i class="bi bi-info-circle text-secondary small"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="saveReport()"
        >
          <i class="fa fa-save"></i>
          {{ "COMMON.SAVE" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="staticBackdrop"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">
          {{ "PIVOT.MODAL.ADD_REPORT" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <p *ngIf="reportform['error'] == false && reportform['message']">
          <app-ncs-alert [message]="reportform['message']" type="success" />
        </p>
        <p *ngIf="reportform['error'] ==  true && reportform['message']">
          <app-ncs-alert [message]="reportform['message']" type="danger" />
        </p>

        <!-- Title Field -->
        <div class="row mb-3">
          <label for="title" class="col-sm-3 col-form-label"
            >{{ "PIVOT.FORM.TITLE" | translate }} :
          </label>
          <div class="col-sm-9">
            <input
              (input)="checkReportLabel($event)"
              id="title"
              name="title"
              [placeholder]="'PIVOT.PLACEHOLDERS.ENTER_TITLE' | translate"
              type="text"
              class="form-control form-control-sm"
              required
              [(ngModel)]="reportform.data['title']"
            />
            <span style="color:red">{{reportform.inputerror?.title}} </span>
          </div>
        </div>

        <!-- Subtitle Field -->
        <div class="row mb-3">
          <label for="subTitle" class="col-sm-3 col-form-label"
            >{{ "PIVOT.FORM.SUBTITLE" | translate }}:</label
          >
          <div class="col-sm-9">
            <input
              id="subTitle"
              name="subTitle"
              [placeholder]="'PIVOT.PLACEHOLDERS.ENTER_SUBTITLE' | translate"
              type="text"
              class="form-control form-control-sm"
              required
              [(ngModel)]="reportform.data['subTitle']"
            />
            <span style="color: red"
              >{{ reportform.inputerror?.subTitle }}
            </span>
          </div>
        </div>

        <!-- Description Field -->
        <div class="row mb-3">
          <label for="description" class="col-sm-3 col-form-label"
            >{{ "PIVOT.FORM.DESCRIPTION" | translate }}:</label
          >
          <div class="col-sm-9">
            <textarea
              id="description"
              name="description"
              [placeholder]="'PIVOT.PLACEHOLDERS.ENTER_DESCRIPTION' | translate"
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="reportform.data['description']"
            >
            </textarea>
            <span style="color: red">{{
              reportform.inputerror?.description
            }}</span>
          </div>
        </div>

        <!-- Fixed Add on Dashboard Checkbox -->

        <div class="row mb-3">
          <div class="col-sm-3"></div>
          <div class="col-sm-9">
            <label class="col-sm-3 col-form-label">{{
              "PIVOT.ADD_ON_DASHBOARD" | translate
            }}</label>
            <div
              class="col-sm-9 d-flex align-items-center justify-content-start"
            >
              <div class="form-check form-switch me-2 mt-3 ">
                <input
                  [(ngModel)]="addOnDashboardReport"
                  class="form-check-input"
                  type="checkbox"
                  id="addOnDashboardReport"
                  name="addOnDashboardReport"
                />
              </div>
              <span
                ncsTooltip
                [title]="'PIVOT.TOOLTIPS.ADD_ON_DASHBOARD' | translate"
                class="ms-1"
              >
                <i class="bi bi-info-circle text-secondary small"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="saveReport()"
        >
          <i class="fa fa-save"></i>
          {{ "COMMON.SAVE" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div
  class="modal fade"
  id="info"
  tabindex="-1"
  aria-labelledby="infoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="h4 modal-title fs-5" id="infoLabel">
          {{ "GUIDELINES.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="guidelines-container">
          <!-- Section 1: Selecting Rows -->
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">1</span>
              {{ "GUIDELINES.SELECTING_ROWS" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.ROWS_DESCRIPTION" | translate }}
            </p>
          </div>

          <!-- Section 2: Selecting Columns -->
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">2</span>
              {{ "GUIDELINES.SELECTING_COLUMNS" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.COLUMNS_DESCRIPTION" | translate }}
            </p>
          </div>

          <!-- Section 3: Selecting Values -->
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">3</span>
              {{ "GUIDELINES.SELECTING_VALUES" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.VALUES_DESCRIPTION" | translate }}
            </p>
          </div>

          <!-- Section 4: Selecting Filters -->
          <div class="mb-4">
            <h6 class="mb-2">
              <span class="badge bg-secondary rounded-pill me-2">4</span>
              {{ "GUIDELINES.SELECTING_FILTERS" | translate }}
            </h6>
            <p class="text-secondary ms-4 ps-1">
              {{ "GUIDELINES.FILTERS_DESCRIPTION" | translate }}
            </p>
          </div>

          <!-- Section 5: Aggregation Functions -->
          <div class="mb-4">
            <h6 class="mb-3">
              <span class="badge bg-secondary rounded-pill me-2">5</span>
              {{ "GUIDELINES.AGGREGATION_FUNCTIONS" | translate }}
            </h6>
            <ul class="list-group list-group-flush bg-transparent ms-4">
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-calculator text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.SUM" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.SUM_DESC" | translate
                  }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-hashtag text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.COUNT" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.COUNT_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-chart-line text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.AVERAGE" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.AVERAGE_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-arrows-alt-v text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.MAX_MIN" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.MAX_MIN_DESC" | translate
                }}</span>
              </li>
              <li class="list-group-item bg-transparent border-0 py-1">
                <i class="fas fa-percent text-primary me-2 fa-fw"></i>
                <b>{{ "GUIDELINES.PERCENT_TOTAL" | translate }}</b> -
                <span class="text-secondary">{{
                  "GUIDELINES.PERCENT_TOTAL_DESC" | translate
                }}</span>
              </li>
            </ul>
          </div>

          <!-- Example Table Section -->
          <div class="mt-4">
            <h5 class="mb-3">{{ "GUIDELINES.EXAMPLE_TITLE" | translate }}</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>{{ "GUIDELINES.EXAMPLE_REGION" | translate }}</th>
                    <th class="text-end">
                      {{ "GUIDELINES.EXAMPLE_RETAIL" | translate }}
                    </th>
                    <th class="text-end">
                      {{ "GUIDELINES.EXAMPLE_WHOLESALE" | translate }}
                    </th>
                    <th class="text-end">
                      {{ "GUIDELINES.EXAMPLE_TOTAL" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="fw-semibold">{{
                        "GUIDELINES.EXAMPLE_NORTH" | translate
                      }}</span>
                    </td>
                    <td class="text-end">$10,000</td>
                    <td class="text-end">$15,000</td>
                    <td class="text-end fw-bold">$25,000</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="fw-semibold">{{
                        "GUIDELINES.EXAMPLE_SOUTH" | translate
                      }}</span>
                    </td>
                    <td class="text-end">$8,000</td>
                    <td class="text-end">$12,000</td>
                    <td class="text-end fw-bold">$20,000</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="fw-semibold">{{
                        "GUIDELINES.EXAMPLE_EAST" | translate
                      }}</span>
                    </td>
                    <td class="text-end">$5,000</td>
                    <td class="text-end">$10,000</td>
                    <td class="text-end fw-bold">$15,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          [title]="'BUTTONS.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
